import performance from './performance';

export { setMark, getMark, setMeasure, measureFunc } from './marks';
export { timeBetweenMarks } from './performance-mark-timer';
export { default as clearMarksWithPrefix } from './clear-marks-with-prefix';
export { default as PerformanceMark } from './set-performance-mark';
export type { PerformanceMarkProps } from './set-performance-mark';
export { PerformanceObserver } from './performance-observer';
export default performance;
